export const lineLayerDefinition = {
    geometryType: 'esriGeometryPolyline',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 112.11951723431639,
        ymin: -34.99775260000001,
        xmax: 131.37433713535938,
        ymax: 24.052603349707056,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'radius',
            type: 'esriFieldTypeDouble',
            alias: 'radius',
            editable: true,
            nullable: true
        },
        {
            name: 'arclength',
            type: 'esriFieldTypeDouble',
            alias: 'arclength',
            editable: true,
            nullable: true
        },
        {
            name: 'delta',
            type: 'esriFieldTypeDouble',
            alias: 'delta',
            editable: true,
            nullable: true
        },
        {
            name: 'centerpointid',
            type: 'esriFieldTypeInteger',
            alias: 'centerpointid',
            editable: true,
            nullable: true
        },
        {
            name: 'radialbearing',
            type: 'esriFieldTypeDouble',
            alias: 'radialbearing',
            editable: true,
            nullable: true
        },
        {
            name: 'tangentbearing',
            type: 'esriFieldTypeDouble',
            alias: 'tangentbearing',
            editable: true,
            nullable: true
        },
        {
            name: 'accuracy',
            type: 'esriFieldTypeInteger',
            alias: 'accuracy',
            editable: true,
            nullable: true
        },
        {
            name: 'boundarylinedistancedatum',
            type: 'esriFieldTypeString',
            alias: 'boundarylinedistancedatum',
            editable: true,
            nullable: true,
            length: 10
        },
        {
            name: 'surveyedindicator',
            type: 'esriFieldTypeString',
            alias: 'surveyedindicator',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'distancederivation',
            type: 'esriFieldTypeString',
            alias: 'distancederivation',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacylinelabel',
            type: 'esriFieldTypeString',
            alias: 'legacylinelabel',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'measurementsource',
            type: 'esriFieldTypeString',
            alias: 'measurementsource',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacylineconstruction',
            type: 'esriFieldTypeString',
            alias: 'legacylineconstruction',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacylinetype',
            type: 'esriFieldTypeString',
            alias: 'legacylinetype',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacydistanceaccuracy',
            type: 'esriFieldTypeString',
            alias: 'legacydistanceaccuracy',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'distanceaccuracy',
            type: 'esriFieldTypeInteger',
            alias: 'distanceaccuracy',
            editable: true,
            nullable: true
        },
        {
            name: 'importlayername',
            type: 'esriFieldTypeString',
            alias: 'importlayername',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacylinesense',
            type: 'esriFieldTypeString',
            alias: 'legacylinesense',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'importfilename',
            type: 'esriFieldTypeString',
            alias: 'importfilename',
            editable: true,
            nullable: true,
            length: 255
        },
        {
            name: 'legacylocallineno',
            type: 'esriFieldTypeInteger',
            alias: 'legacylocallineno',
            editable: true,
            nullable: true
        },
        {
            name: 'legacyrecordid',
            type: 'esriFieldTypeInteger',
            alias: 'legacyrecordid',
            editable: true,
            nullable: true
        },
        {
            name: 'bearing',
            type: 'esriFieldTypeString',
            alias: 'bearing',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'totallotboundaryid',
            type: 'esriFieldTypeInteger',
            alias: 'totallotboundaryid',
            editable: true,
            nullable: true
        },
        {
            name: 'lineids',
            type: 'esriFieldTypeString',
            alias: 'lineids',
            editable: true,
            nullable: true,
            length: 10024
        },
        {
            name: 'distance',
            type: 'esriFieldTypeDouble',
            alias: 'distance',
            editable: true,
            nullable: true
        },
        {
            name: 'interestids',
            type: 'esriFieldTypeString',
            alias: 'interestids',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'pointids',
            type: 'esriFieldTypeString',
            alias: 'pointids',
            editable: true,
            nullable: true,
            length: 10024
        },
        {
            name: 'frompointid',
            type: 'esriFieldTypeInteger',
            alias: 'frompointid',
            editable: true,
            nullable: true
        },
        {
            name: 'topointid',
            type: 'esriFieldTypeInteger',
            alias: 'topointid',
            editable: true,
            nullable: true
        },
        {
            name: 'category',
            type: 'esriFieldTypeInteger',
            alias: 'category',
            editable: true,
            nullable: true
        },
        {
            name: 'visible',
            type: 'esriFieldTypeString',
            alias: 'visible',
            editable: true,
            nullable: true,
            length: 5
        },
        {
            name: 'hiddenonenlargements',
            type: 'esriFieldTypeString',
            alias: 'hiddenonenlargements',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
